import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './App.css';
import './index.css';
import { initializePixel } from './utils/metaPixel.js';

// Replace with your actual Meta Pixel ID
const META_PIXEL_ID = '1484123872768595';

// Initialize Meta Pixel
initializePixel(META_PIXEL_ID);

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);